import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ISevereWeatherLocation } from '../models/severeWeatherLocation';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class SevereWeatherLocationService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getSevereWeatherLocations(buildingId: string): Observable<{has_error: boolean, message: string, data: ISevereWeatherLocation[]}> {
        const url = environment.apiBaseUrl + endpoints.getSevereWeatherLocations.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: ISevereWeatherLocation[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createSevereWeatherLocation(buildingId: string, data: Partial<ISevereWeatherLocation>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.createSevereWeatherLocation.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateSevereWeatherLocation(buildingId: string, itemId: string, data: Partial<ISevereWeatherLocation>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateSevereWeatherLocation
            .replace(':buildingId', buildingId)
            .replace(':itemId', itemId);
        return this.http.put<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteSevereWeatherLocation(buildingId: string, itemId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.deleteSevereWeatherLocation
            .replace(':buildingId', buildingId)
            .replace(':itemId', itemId);
        return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
